import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './EspaPage.css';

const ESPA_LOGO = 'https://customer-assets-rejwkqb3.emergentagent.net/job_bb24eabe-6ef2-4d89-a7b7-511a398af039/artifacts/awxg4lzk_antagonistikotitaframeEL.jpg';

const EspaPage = () => {
  const navigate = useNavigate();
  const { t, lang, toggleLang } = useLanguage();

  return (
    <div className="espa-page" data-testid="espa-page">
      <header className="espa-topbar">
        <button className="espa-back" onClick={() => navigate('/')} data-testid="espa-back">
          <ArrowLeft size={18} />
          <span>{t('common.home')}</span>
        </button>
        <button
          className="espa-lang"
          onClick={toggleLang}
          aria-label={lang === 'el' ? 'Switch to English' : 'Αλλαγή στα Ελληνικά'}
        >
          <span>{lang === 'el' ? '🇬🇧 EN' : '🇬🇷 EL'}</span>
        </button>
      </header>

      <main className="espa-container">
        <div className="espa-hero">
          <img
            src={ESPA_LOGO}
            alt="ΕΣΠΑ 2021-2027 - Πρόγραμμα Ανταγωνιστικότητα"
            className="espa-hero__image"
          />
        </div>

        <article className="espa-content">
          <h1 className="espa-h1">{t('espa.title')}</h1>

          <div className="espa-body">
            <p>{t('espa.p1')}</p>
            <p>{t('espa.p2')}</p>
          </div>

          <div className="espa-footer-note">
            <p>{t('espa.footer')}</p>
          </div>
        </article>
      </main>
    </div>
  );
};

export default EspaPage;
